<template>
  <el-table class="batch-transfer-table common-el-table-styles" height="320" :data="list" border ref="tableRef">
    <el-table-column label="序号">
      <template slot-scope="{ $index }">
        <div>{{ $index + 1 }}</div>
      </template>
    </el-table-column>
    <el-table-column label="转出账号" class-name="parent-col">
      <el-table-column prop="accountId" label="账号ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="adAccount" label="转出账号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="advertiserId" label="计划主ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mediaName" label="媒体" show-overflow-tooltip></el-table-column>
      <el-table-column prop="opNames" label="管理人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="agentName" label="代理商"></el-table-column>
      <el-table-column label="实时总余额" width="90" prop="accountMoney"> </el-table-column>

      <el-table-column label="转账方式" width="120">
        <template slot-scope="{ row }">
          <el-select style="width: 100%" v-model="row.isSelfDeal">
            <el-option
              v-for="item in [
                { label: '自行转账', value: 1 },
                { label: '财务转账', value: 0 }
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column v-if="showSpecialCols" prop="bidPrepayValid" label="现金余额"></el-table-column>
      <el-table-column v-if="showSpecialCols" prop="bidCreditValid" label="授信余额"></el-table-column>
      <el-table-column v-if="showSpecialCols" prop="grantValid" label="赠送余额"></el-table-column>
      <el-table-column v-if="showSpecialCols" prop="virturlValid" label="补偿虚拟金"></el-table-column>
      <el-table-column v-if="showSpecialCols" prop="specialGiftValid" label="专项充值金"></el-table-column>

      <el-table-column v-if="showSpecialCols" width="130" label="转出资金类型">
        <template slot-scope="{ row }">
          <!-- 腾讯广告 -->
          <el-select class="fund-type-selector" v-if="row.mediaId === mediaTypeEnum.GDT" v-model="row.transferFundType" style="width: 100%">
            <el-option v-for="item in gdtFundType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>

          <!-- 头条 -->
          <el-select
            class="fund-type-selector"
            v-if="row.mediaId === mediaTypeEnum.TOUTIAO"
            v-model="row.transferFundType"
            style="width: 100%"
          >
            <el-option v-for="item in toutiaoFundType" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="转出账面金额" width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.transferBalance" placeholder="请输入金额"></el-input>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="转入账号" class-name="parent-col transfer-bg-highlight">
      <el-table-column class-name="transfer-bg-highlight" label="转入账号" width="180">
        <template slot-scope="{ row, $index }">
          <el-select
            style="width: 100%"
            class="account-selector"
            filterable
            v-model="row.transferAccountId"
            :loading="row.loading"
            @focus="onAccoutSelectorFocus(row, $index)"
            @change="onRowTransferAccountChange($event, row, $index)"
          >
            <el-option v-for="item in getAvailableAccounts()[row.accountId]" :key="item.id" :label="item.adAccount" :value="item.id">
              <span>{{ item.adAccount }}</span>
              <span v-if="item.accountMoney">&ensp;余额：{{ item.accountMoney }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        class-name="transfer-bg-highlight"
        prop="transferAccountInfo.mediaName"
        label="媒体"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        class-name="transfer-bg-highlight"
        prop="transferAccountInfo.accountMoney"
        label="实时账号余额"
        width="150"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column class-name="transfer-bg-highlight" prop="transferAccountInfo.opNames" label="管理人员"></el-table-column>
      <el-table-column class-name="transfer-bg-highlight" prop="transferAccountInfo.agentName" label="代理商" width="150">
      </el-table-column>
    </el-table-column>

    <el-table-column label="操作" fixed="right">
      <template slot-scope="{ $index }">
        <el-button type="text" @click="removeRow($index)">移除</el-button>
        <el-button type="text" @click="copyRow($index)">复制</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { gdtFundType, toutiaoFundType, toutiaoFundTypeEnum, gdtFundTypeEnum, mediaTypeEnum } from './data.js'
import { clone } from '@/common/js/just.js'
export default {
  name: 'transferOut',
  props: {
    list: {
      type: Array
    }
  },
  inject: ['getAccountRealtimeBalance', 'updateTableRow', 'getAvailableAccounts'],
  computed: {
    hasToutiao() {
      return this.list.some((item) => item.mediaId === mediaTypeEnum.TOUTIAO)
    },
    hasGdt() {
      return this.list.some((item) => item.mediaId === mediaTypeEnum.GDT)
    },
    showSpecialCols() {
      return this.hasGdt || this.hasToutiao
    }
  },

  data() {
    return {
      gdtFundType,
      toutiaoFundType,
      toutiaoFundTypeEnum,
      gdtFundTypeEnum,
      mediaTypeEnum
    }
  },

  methods: {
    /**
     * @description: 点击账号选择器获取可用账号
     * @param {*} row
     * @param {*} idx
     */
    async onAccoutSelectorFocus(row, idx) {
      this.updateTableRow(row, idx)
    },
    /**
     * @description: 显示转入账号信息
     * @param {*} e
     * @param {*} row
     */
    onRowTransferAccountChange(e, row, idx) {
      // 找到当前转出账号信息
      const availableAccounts = this.getAvailableAccounts()
      const transferAccountInfo = availableAccounts[row.accountId].find((item) => item.id === e)

      const newList = this.list.map((item, i) => {
        if (i === idx) {
          return { ...item, transferAccountInfo }
        }
        return item
      })

      this.$emit('update-list', newList)
    },

    /**
     * @description: 移除一行
     */
    removeRow(idx) {
      const newList = this.list.filter((_, i) => i !== idx)
      this.$emit('update-list', newList)
    },
    /**
     * @description: 复制一行
     */
    copyRow(idx) {
      const newList = clone(this.list)
      newList.splice(idx, 0, this.list[idx])
      this.$emit('update-list', newList)
    }
  }
}
</script>
